import * as Sentry from "@sentry/nuxt";

Sentry.init({
    // If set up, you can use your runtime config here
    // dsn: useRuntimeConfig().public.sentry.dsn,
    // dsn: "https://5c1899693b5125d5ec8d311e46b475f3@o4507792110583808.ingest.de.sentry.io/4508188105572432",
    dsn: "https://e2a0b13f0af945cd88c3651a232ad11a@bugsink.northland.coffee/1",
    integrations: [Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 0.1, // Sample 10% of transactions to reduce main-thread overhead
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/api\.northland-co\.com/],
    // Session Replay - only capture on actual error to preserve client CPU and Speed Index
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
});